export const messagesSuccess = {
  pt: {
    message: {
      accessPointGroupCreated: "Grupo de AP criado com sucesso!",
      apiRevoked: "API revogada com sucesso!",
      automationDeleted: "Automação deletada com sucesso!",
      automationSaved: "Automação salva com sucesso!",
      avatarUpdated: "Avatar atualizado com sucesso!",
      credentialsUpdated: "Credenciais atualizadas com sucesso!",
      dayEdited: "Dia editado com sucesso!",
      deviceCreated: "Aparelho criado com sucesso!",
      deviceEdited: "Aparelho editado com sucesso!",
      domainDeleted: "Domínio deletado com sucesso!",
      draftDeleted: "Rascunho deletado com sucesso!",
      draftSaved: "Rascunho salvo com sucesso!",
      elementDeleted: "Elemento deletado com sucesso",
      emailUpdated: "E-mail atualizado com sucesso!",
      formCreated: "Formulário criado com sucesso!",
      formDeleted: "Formulário deletado com sucesso!",
      formEdited: "Formulário editado com sucesso!",
      integrationActivated: "Integração ativada com sucesso!",
      integrationDisabled: "Integração desativada com sucesso!",
      integrationEdited: "Integração editada com sucesso!",
      integrationRegistered: "Integração cadastrada com sucesso!",
      loginTypeCreated: "Tipo de login criado com sucesso!",
      loginTypeDeleted: "Tipo de login deletado com sucesso!",
      loginTypeEdited: "Tipo de login editado com sucesso!",
      marketingSendCreated: "Envio para o marketing criado com sucesso!",
      marketingSendDeleted: "Envio para o marketing deletado com sucesso!",
      marketingSendEdited: "Envio para o marketing editado com sucesso!",
      modificationCompleted: "Alteração concluída!",
      operationSuccessful: "Operação executada com sucesso!",
      permissionChanged: "Permissão alterada com sucesso!",
      pixelSaved: "Pixel salvo com sucesso!",
      recordSaved: "Registro salvo com sucesso!",
      recordsDiscarded: "Registros descartados com sucesso!",
      recordsBeingResent:
        "Os registros estão sendo reenviados, isso pode levar algum tempo",
      redefinitionLink:
        "O link de redefinição de senha está na área de transferência. Utilize Ctrl + V para colar no local desejado.",
      smsEdited: "SMS editado com sucesso!",
      spotCreated: "Local criado com sucesso!",
      spotEdited: "Local editado com sucesso!",
      spotsGroupCreated: "Grupo de locais criado com sucesso!",
      spotsGroupEdited: "Grupo de locais editado com sucesso!",
      statusUpdated: "Status atualizado com sucesso!",
      textCopied: "Texto copiado com sucesso!",
      trackerCreated: "Rastreador criado com sucesso!",
      trackerEdited: "Rastreador editado com sucesso!",
      userCreated: "Usuário criado com sucesso!",
      userDeleted: "Usuário deletado com sucesso!",
      userEdited: "Usuário editado com sucesso!",
      userMaster: "Usuário alterado para Master com sucesso!",
      userUpdated: "Usuário atualizado com sucesso!",
      valueCopied: "Valor copiado com sucesso!",
      welcomeEmailResent:
        "Re-envio de e-mail de Boas vindas feito com sucesso.",
      domainChanged: "Domínio editado com sucesso.",
      passwordUpdated: "Senha atualizada com sucesso!",
    },
  },
  es: {
    message: {
      accessPointGroupCreated: "¡Grupo AP creado con éxito!",
      apiRevoked: "¡API revocada con éxito!",
      automationDeleted: "¡Automatización eliminada con éxito!",
      automationSaved: "¡La automatización ahorra con éxito!",
      avatarUpdated: "¡Avatar actualizado con éxito!",
      credentialsUpdated: "¡Credenciales actualizadas exitosamente!",
      dayEdited: "¡Día editado con éxito!",
      deviceCreated: "¡Dispositivo creado con éxito!",
      deviceEdited: "¡Dispositivo editado exitoso!",
      domainDeleted: "¡Dominio eliminado exitoso!",
      draftDeleted: "¡Draft eliminado exitoso!",
      draftSaved: "¡Garras guardadas con éxito!",
      elementDeleted: "Elemento eliminado con éxito",
      emailUpdated: "¡Correo electrónico actualizado con éxito!",
      formCreated: "¡Formulario creado con éxito!",
      formDeleted: "¡Formulario eliminado con éxito!",
      formEdited: "¡Formulario editado con éxito!",
      integrationActivated: "¡Integración activada exitosa!",
      integrationDisabled: "¡Integración desactivada con éxito!",
      integrationEdited: "¡Integración editada con éxito!",
      integrationRegistered: "¡Integración registrada con éxito!",
      loginTypeCreated: "¡Tipo de inicio de sesión creado con éxito!",
      loginTypeDeleted: "¡El tipo de inicio de sesión se eliminó con éxito!",
      loginTypeEdited: "¡Tipo de inicio de sesión editado con éxito!",
      marketingSendCreated: "¡Envío a marketing creado con éxito!",
      marketingSendDeleted: "¡Envío a marketing eliminado con éxito!",
      marketingSendEdited: "¡Envío a marketing editado con éxito!",
      modificationCompleted: "¡Cambio completado!",
      operationSuccessful: "¡Operación ejecutada con éxito!",
      permissionChanged: "¡Cambió con éxito el permiso!",
      pixelSaves: "¡Pixel guardado con éxito!",
      recordSaved: "¡Registro guardado con éxito!",
      recordsDiscarded: "¡Registros descartados exitosamente!",
      recordsBeingResent:
        "Los registros se están reenviando; esto puede tardar algún tiempo",
      redefinitionLink:
        "El enlace de redefinición de contraseña está en el área de transferencia. Use CTRL + V para pegar en la ubicación deseada",
      smsEdited: "¡SMS editado con éxito!",
      spotCreated: "¡Lugar creado con éxito!",
      spotEdited: "¡Local editado con éxito!",
      spotsGroupCreated: "¡Grupo local creado con éxito!",
      spotsGroupEdited: "¡Grupo de lugares publicados con éxito!",
      statusUpdated: "¡Estado actualizado exitosamente!",
      textCopied: "¡Texto copiado con éxito!",
      trackerCreated: "¡Rastreador creado con éxito!",
      trackerEdited: "¡Rastreador editado con éxito!",
      userCreated: "¡Usuario creado con éxito!",
      userDeleted: "¡Usuario eliminado exitoso!",
      userEdited: "¡Usuario editado con éxito!",
      userMaster: "¡El usuario cambió a Master con éxito!",
      userUpdated: "¡Usuario actualizado con éxito!",
      valueCopied: "¡Valor copiado con éxito!",
      welcomeEmailResent:
        "Vuelva a ir del correo electrónico de bienvenida realizado con éxito",
      domainChanged: "Dominio editado con éxito.",
      passwordUpdated: "¡Contraseña actualizada exitosamente!",
    },
  },
  en: {
    message: {
      accessPointGroupCreated: "AP Group successfully created!",
      apiRevoked: "API successfully revoked!",
      automationDeleted: "Automation deleted successfully!",
      automationSaved: "Automation successfully saved!",
      avatarUpdated: "Avatar successfully updated!",
      credentialsUpdated: "Credentials updated successfully!",
      dayEdited: "Day successfully edited!",
      deviceCreated: "Device successfully created!",
      deviceEdited: "Device successfully edited!",
      domainDeleted: "Domain successfully deleted!",
      draftDeleted: "Draft successfully deleted!",
      draftSaved: "Draft saved successfully!",
      elementDeleted: "Element successfully deleted!",
      emailUpdated: "Email successfully updated!",
      formCreated: "Form created successfully!",
      formDeleted: "Form deleted successfully!",
      formEdited: "Form edited successfully!",
      integrationActivated: "Integration activated successfully!",
      integrationDisabled: "Integration disabled successfully!",
      integrationEdited: "Integration successfully edited!",
      integrationRegistered: "Integration successfully registered!",
      loginTypeCreated: "Login type created successfully!",
      loginTypeDeleted: "Login type deleted successfully!",
      loginTypeEdited: "Login type edited successfully!",
      marketingSendCreated: "Marketing send successfully created!",
      marketingSendDeleted: "Marketing send successfully deleted!",
      marketingSendEdited: "Marketing send successfully edited!",
      modificationCompleted: "Modification completed!",
      operationSuccessful: "Operation executed successfully!",
      permissionChanged: "Permission changed successfully!",
      pixelSaved: "Pixel saved successfully!",
      recordSaved: "Record successfully saved!",
      recordsDiscarded: "Records successfully discarded!",
      recordsBeingResent: "Records are being resent, this may take some time",
      redefinitionLink:
        "The password reset link is on the clipboard. Use Ctrl + V to paste in the desired location.",
      smsEdited: "SMS successfully edited!",
      spotCreated: "Spot successfully created!",
      spotEdited: "Spot successfully edited!",
      spotsGroupCreated: "Spots group successfully created!",
      spotsGroupEdited: "Spots group successfully edited!",
      statusUpdated: "Status updated successfully!",
      textCopied: "Text successfully copied!",
      trackerCreated: "Tracker successfully created!",
      trackerEdited: "Tracker successfully edited!",
      userCreated: "User successfully created!",
      userDeleted: "User successfully deleted!",
      userEdited: "User successfully edited!",
      userMaster: "User successfully changed to Master!",
      userUpdated: "User updated successfully!",
      valueCopied: "Value successfully copied!",
      welcomeEmailResent: "Welcome email re-send successful.",
      domainChanged: "Domain successfully edited!",
      passwordUpdated: "Password updated successfully!",
    },
  },
};
